import { feeInspection } from "../../../service/apiService";
import { AppConstants } from "../../../constants/constant";
import { useFormContext } from "../../../common/contexts/FormContext";
import { useFormConfigContext } from "../../../common/contexts/FormConfigContext";

export const useFeeInspection = () => {
  const { formValues } = useFormContext();
  const { formConfig } = useFormConfigContext();
  const handleFeeInspection = async (franchiseWebLocationId: string) => {
    // Determine fee name to search
    const feeNameToSearch =
      formConfig?.feeKeyword ||
      AppConstants.INSPECTION_FEE ||
      AppConstants.DIGNOSTIC_FEE;

    // Fetch fee inspection value
    const feeInspectionValue = await feeInspection(
      formValues?.zipcode as string,
      franchiseWebLocationId,
      formConfig?.feeDetails?.endPointType as string
    );

    try {
      if (feeInspectionValue) {
        const feeData = feeInspectionValue.filter(
          (item) => (item.feeName || item.name) === feeNameToSearch
        );

        const feeDataWithoutDeleteTime = feeData.find(
          (item) => item?.deletedDateTime === null
        );

        const fee =
          feeDataWithoutDeleteTime?.fee ||
          feeDataWithoutDeleteTime?.defaultFee ||
          null;

        sessionStorage.setItem("inspectionFeeValue", fee);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return { handleFeeInspection };
};
